<template>
	<div class="exam" ref="homes">
		<div class="main">
			<div class="headers"><Header /></div>
			<div class="mian-body">
				<div class="main-side">
					<div class="title">
						<div class="title_border"></div>
						<div class="title_content">答题卡</div>
					</div>
					<div class="card-content-list">
						<div class="card-content">
							<div class="card-content-title">(共{{ dataLists.length }}题)</div>
							<div class="box-list">
								<div class="box normal-box question_cbox" v-for="(item, index) in dataLists" @click="scrollview(index)" :key="index">
									<div class="checki" :class="{ checked: item.isopsanswers == 1 }">{{ index + 1 }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-center">
					<div class="body-wrapper">
						<div class="questions">
							<div class="questions-title">共{{ dataLists.length }}题</div>
							<div class="questions-content">
								<div class="question-content" v-for="(item, i) in dataLists" :key="i" :ref="'text' + i" :id="'text' + i">
									<div v-if="item.SQT_Name == '判断题'">
										<div class="exam-question">
											<p class="exam-pd" v-if="item.SQT_Name == '判断题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index">
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.IsSelect ? '#5fbd9a' : son.SQO_IsAnswer?'#00a5f8':'', color: son.IsSelect || son.SQO_IsAnswer ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>

									<div v-if="item.SQT_Name == '多选题'">
										<div class="exam-question">
											<p class="exam-dxt" v-if="item.SQT_Name == '多选题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index" >
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.IsSelect ? '#5fbd9a' : son.SQO_IsAnswer?'#00a5f8':'', color: son.IsSelect || son.SQO_IsAnswer ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>

									<div v-if="item.SQT_Name == '单选题'">
										<div class="exam-question">
											<p class="exam-dxtt" v-if="item.SQT_Name == '单选题'">{{ item.SQT_Name }}</p>
											<span class="question-index ellipsis">{{ i + 1 }}.</span>
											{{ item.SQB_Question }}
										</div>
										<div>
											<div class="answers" v-for="(son, index) in item.Questionoptions" :key="index" >
												<!-- <el-radio v-model="radio[index]" :label="son.SQB_Question"  >{{ son.value=="A"?'对':'错' }}</el-radio> -->
												<div class="answersqust">
													<p
														class="clicrs"
														:style="{ background: son.IsSelect ? '#5fbd9a' : son.SQO_IsAnswer?'#00a5f8':'', color: son.IsSelect || son.SQO_IsAnswer ? '#fff' : '' }"
													>
														{{ son.value }}
													</p>
													<p>{{ son.SQO_OptionName }}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-right">
					<div class="nav">
						<!-- <div class="cilcie">
							<div style="font-size: 40px;">
								{{Scores}}
							</div>
							<img src="@/assets/scores.svg" mode=""></img>
						</div> -->
					</div>
				</div>
			</div>
		</div>

		
	</div>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

import Header from '@/components/header/Header.vue';

import { UserPerDetails,getGetQuetype ,PaperDetailsjs } from '@/request/api/homesview/yunhomes/yunhom.js';

import { uniqueFunc } from '@/utils/utils';

export default {
	data() {
		return {
			checkData: [],
			checking: false,
			name: '',
			title: '',
			customColor: '#55b6da',
			percentage: 0,
			Scores:"",
			full_score: '',
			signView: false, // 正确与错误
			passView: false, // 通过或者未通过
			checkResult: false, // 左侧栏、右侧栏、答题结果栏
			options: [
				{
					value: '0',
					label: '全部'
				},
				{
					value: '1',
					label: '答对'
				},
				{
					value: '2',
					label: '答错'
				}
			],
			checkVal: '0',
			examinationData: '',
			allRadio: [], //提交给后台的真题数据
			radio: [], //单选真题答案,
			checkLen: [],
			obj: { value: '' },
			answersData: [],
			// 弹窗
			dialogVisible: false,
			exminxslist: [],
			exminxslistobj: null,
			exminxslistobjs: {},
			// 试题列表
			dataLists: [],
			ListModels: [],
			// 点击交卷不用提示直接退出
			iseaminmroe: false,
			starttimer: '',
			quetype: []
		};
	},
	watch: {},
	created() {
		AppOptions.appEmpty = true;
		
	},

	mounted() {
		this.name = '考试';
		this.Scores = this.$route.query.SSP_Scores
		
		
		this.get();
	},

	methods: {
		// 获取考试题
		get() {
			getGetQuetype().then(res=>{
				this.quetype = res.data.data
			})
			
			this.dialogexminx();
		},
		// 点击滑动
		scrollview(i) {
			let domsg = eval('this.$refs.text' + i)[0];
			domsg.scrollIntoView({
				behavior: 'smooth', // 平滑过渡
				block: 'start' // 上边框与视窗顶部平齐
			});
			// console.log(domsg);
		},
		
		dialogexminx() {
			let exminxslistobj = {
				SPA_GUID: this.$route.query.SPA_GUID
			};
			PaperDetailsjs({
				SPA_GUID:exminxslistobj.SPA_GUID,
			}).then(res => {
				if (res.data.code >= 0) {
					let dataLists = []
					dataLists = [...res.data.data.SingleOptionlist,...res.data.data.MultipleOptionlist,...res.data.data.JudgeOptionlist]
					// this.exminxslistobjs = exminxslistobj;
				
					this.dataLists = dataLists;
					this.exminxslistobjs.SPA_GUID = res.data.data.SPA_GUID;
					this.getdataLists();
				}
			});
		},
		getdataLists() {
			// abc数组主要是数据里面没有abc，所以我在每一个数据都添加一个abc的值，用来渲染和判断
			let chioceszm = ['A', 'B', 'C', 'D', 'F', 'E', 'G', 'H', 'I', 'j', 'K', 'L'];

			this.dataLists.forEach((item, index) => {
				// 这里是加题型
				this.quetype.forEach(itm => {
					if (itm.SQT_GUID == item.SQT_GUID) {
						item.topicType = itm.SQT_Name;
						item.SQT_Name = itm.SQT_Name;
					}
				});
				// 这里是加前面的题目号
				item.SQB_Quesion = index + 1 + '、' + item.SQB_Question;
				// 这个好像也是加题目号用的我忘记了
				item.numstrst = index + 1;
				// 初始化判断值，他为true说明状态为选中的
				item.answerResult = false;
				item.isopsanswers = 0;
				// 这里添加，初步判断多选不可能超过12，如果有这种多选那么自行添加
				item.Questionoptions.forEach((itm, idx) => {
					itm.value = chioceszm[idx];
					itm.isOptionAnswer = 0;
				});
			});
			// console.log(this.dataLists)
		}
	},
	beforeRouteEnter(to, from, next) {
		next(() => {
			// 改变html背景
			document.querySelector('html').style.cssText = `
	        background: #ecf1f6;
	      `;
		});
	},
	beforeRouteLeave(to, from, next) {
		// 消除html背景
		document.querySelector('html').style.cssText = `background: #fff;`;
		// 中途退出提示
		if (this.iseaminmroe) {
			this.$confirm('确定中途退出吗, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					next();
				})
				.catch();
		} else {
			next();
		}
	},
	components: {
		Header
	}
};
</script>

<style scoped lang="less">
.cilcie {
	position: absolute;
	right: 6%;
	top: 7%;
	border-radius: 50%;
	box-sizing: border-box;
	color: #ff2121;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	img {
		width: 120px;
		height: 55px;
		margin-top: 10px;
	}

}	
	

.headers {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 999;
}

.answersqust {
	display: flex;
	align-items: center;
	margin-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
	.clicrs {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1px solid #ccc;
		margin-right: 10px;
		text-align: center;
	}
}

.exminrlist {
	width: 100%;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	.exminritems {
		border: 1px solid #ccc;
		padding: 20px;
		width: 46%;
		margin-right: 2%;
		box-sizing: border-box;
		border-radius: 10px;
		margin-bottom: 10px;
		cursor: pointer;
		border-top: 5px solid;

		.exminrp {
			margin-bottom: 10px;
			font-size: 18px;
		}
	}
}

/deep/ .el-progress__text {
	display: none;
}
/deep/ .el-select .el-input__inner:focus {
	border-color: #55b6da;
}
/deep/ .el-select {
	border: none;
}
/deep/ .el-select-dropdown__item.selected {
	color: #55b6da !important;
	font-weight: bold;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
	color: #55b6da;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
	border-color: #55b6da;
	background: #55b6da;
}
/deep/ .el-radio__inner:hover {
	border-color: #55b6da;
}
/deep/ .el-radio {
	display: block;
	margin: 20px 0;
}
.inner {
	padding: 0px 90px;
}
.exam {
	background: #ecf1f6;
	height: 100%;
	min-height: 100%;
}
.main {
	.header-wrapper {
		height: 80px;
		width: 100%;
		line-height: 80px;
		background: #ffffff;
		box-shadow: 0 2px 4px 0 rgba(153, 153, 153, 0.1);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1040;
		.left {
			display: flex;
			align-items: center;
			font-size: 18px;
			.logo {
				width: 150px;
				margin-right: 120px;
				img {
					width: 100%;
				}
			}
		}
		.right {
			div {
				float: right;
				font-size: 16px;
			}
			.esc {
				width: 120px;
				height: 38px;
				line-height: 38px;
				margin: 21px 0;
				color: #fff;
				background: #55b6da;
				border-radius: 30px;
				text-align: center;
				cursor: pointer;
				user-select: none;
				&:hover {
					filter: brightness(80%);
				}
				&:active {
					filter: brightness(60%);
				}
			}
			.name {
				margin-right: 55px;
				font-weight: bold;
			}
		}
	}
	.mian-body {
		.main-side {
			display: inline-block;
			height: calc(100% - 140px);
			position: fixed;
			top: 120px;
			width: 240px;
			left: 90px;
			background: #fff;
			box-shadow: 0 1px 4px 0 rgba(58, 62, 81, 0.1);
			.title {
				position: relative;
				text-align: left;
				margin: 23px 0px 0px 12px;
				.title_border {
					display: inline-block;
					width: 4px;
					height: 26px;
					background: #33394b;
					border-radius: 15px;
					position: absolute;
					top: 0;
					bottom: 0;
					margin: auto;
				}
				.title_content {
					margin-left: 14px;
					font-size: 18px;
					font-weight: 600;
					color: #27274a;
				}
			}
			.card-content-list {
				height: calc(100% - 38px);
				overflow: auto;
				.card-content {
					padding: 0 12px 0 12px;
					position: relative;
					.card-content-title {
						font-size: 14px;
						color: #27274a;
						font-weight: 600;
						padding-bottom: 12px;
						padding-top: 20px;
					}
					.box-list {
						padding-bottom: 0;
						position: relative;
						left: -5px;
						font-size: 0;
						margin-right: -15px;
						.box {
							height: auto;
							line-height: unset;
							position: relative;
							margin-bottom: 15px;
							font-size: 14px;
							width: 35px;
							margin-top: unset;
							margin-right: unset;
							display: inline-block;
							.checki {
								// border: 1px solid #dcdfe6;
								// color: #dcdfe6;
								width: 27px;
								height: 27px;
								text-align: center;
								display: inline-block;
								line-height: 27px;
								background: #fff;
								border-radius: 50%;
								cursor: pointer;
							}
							.checked {
								color: #fff;
								background: #55b6da;
							}
							.check-error {
								color: #fff;
								background: #ec6941;
							}
						}
					}
				}
			}
		}
		.main-center {
			margin: 75px 230px 0px 360px;
			height: 100vh;
			.body-wrapper {
				color: #27274a;
				width: 100%;
				background: #ffffff;
				border: 1px solid #dedede;
				border-radius: 4px;
				.questions-title {
					font-size: 18px;
					line-height: 25px;
					padding: 18px 20px;
					background: #fafafa;
					border-bottom: 1px solid #dedede;
				}
				.questions-content {
					padding-left: 30px;
					padding-right: 75px;
				}
				.question-content {
					border-bottom: 1px solid #dedede;
					padding: 15px 0;
					position: relative;
					&:last-child {
						border: none;
					}
					.exam-question {
						font-size: 16px;
						line-height: 22px;
						margin-bottom: 10px;
						padding-left: 20px;
						position: relative;
						// display: flex;

						p.exam-dxtt {
							background-color: #55b6da;
						}

						p.exam-dxt {
							background-color: #55aaff;
						}

						p {
							background: red;
							color: #fff;
							border-radius: 10px;
							margin: 0 10px;
							height: 16px;
							width: 75px;
							line-height: 16px;
							font-size: 12px;
							text-align: center;
							display: inline-block;
						}

						.question-index {
							color: #55b6da;
							position: absolute;
							left: -25px;
							top: 0;
							display: inline-block;
							width: 40px;
							line-height: 22px;
							text-align: right;
						}
					}
					.analysis {
						overflow: auto;
						background: rgba(222, 222, 222, 0.2);
						border-radius: 4px;
						padding: 15px 20px;
						line-height: 24px;
						margin-top: 10px;
						position: relative;
						.question-icon-wrapper {
							position: absolute;
							right: 10px;
							top: 14px;
							.sign {
								width: 48px;
								height: 28px;
								position: absolute;
								color: #fff;
								top: 10px;
								right: 0;
								font-size: 14px;
								border-radius: 2px;
								line-height: 28px;
								text-align: center;
								font-style: normal;
							}
							.icon-error {
								background: #ec6941;
							}
							.icon-right {
								background: #55b6da;
							}
						}
						.analysis-row {
							font-size: 14px;
							margin-top: 10px;
							min-height: 24px;
							padding-left: 80px;
							padding-right: 60px;
							position: relative;
							.analysis-title {
								position: absolute;
								width: 80px;
								left: 0;
								top: 0;
							}
							.question-analysis {
								text-align: justify;
							}
							.error {
								color: #f72a3a;
								font-weight: bold;
							}
						}
					}
				}
			}
		}
		.main-right {
			right: 90px;
			bottom: 20px;
			position: fixed;
			top: 120px;
			width: 120px;
			.nav {
				color: #27274a;
				line-height: 20px;
				padding: 0 10px;
				background: #ffffff;
				box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
				border-radius: 4px;
				margin-bottom: 10px;
				text-align: center;
				position: relative;
				
				
				.menu-item {
					padding: 14px 0;
					border-bottom: 1px solid #dedede;
				}
				.menu-item:last-child {
					border: none;
				}
				.pass {
					color: #55b6da;
				}
				.item-result,
				.unpass {
					color: rgb(236, 105, 65);
				}
				.item-label {
					margin-bottom: 6px;
				}
				.item-data {
					font-size: 18px;
					line-height: 22px;
					color: #ff0000;
					font-weight: 400;
				}
				.item-press {
					line-height: 17px;
					margin-bottom: 7px;
					color: #27274a;
					font-size: 14px;
					& span:nth-child(1)::after {
						content: '/';
						margin: 0 5px;
					}
				}
			}
			.btn {
				bottom: -10px;
				position: absolute;
				width: 100%;
				margin-bottom: 10px;
				cursor: pointer;
				text-align: center;
				height: 38px;
				line-height: 22px;
				border-radius: 20px;
				color: #fff;
				background: #33394b;
				user-select: none;
				&:hover {
					width: 120%;
				}
			}
		}
	}
}
</style>
